import SettingsVM from './settings-vm';
export default {
  prepUI: function() {
    // Remove any current dynamic elements (for pjax popstate support)
  },

  init : function(ele) {
    console.log('Kadenze.InstitutionSettingsEditor initialization function called');
    var data = JSON.parse($('#settings_json').val());
    var validationOptions = Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS;
    ko.applyBindingsWithValidation(new SettingsVM(data), ele, validationOptions);
  }
};

